import { FileType } from "../types";

export type FileWithPreviewToUpload = {
  file: File,
  url: string
  thumbFile: File | null,
  thumbUrl: string | null,
  uploadInfo?: Partial<{
    type: FileType
    spoiler: boolean
  }>
}

export type FilesWithPreviewToUpload = Array<FileWithPreviewToUpload>

export type SelectedFileWithPreviewToUpload = {
  item: FileWithPreviewToUpload,
  index: null | number
}

export function filesWithPreviewMapper(_files: FileList, uploadInfo: FileWithPreviewToUpload['uploadInfo'] = {}): FilesWithPreviewToUpload {
  const files: FilesWithPreviewToUpload = []

  for (const file of _files) {
    files.push({
      file,
      url: window!.URL!.createObjectURL(file),
      thumbFile: null,
      thumbUrl: '',
      uploadInfo: { ...uploadInfo }
    })
  }

  return files
}
